import PaypalIcon from "./component-library163.mjs";
import PaypalLogo from "./component-library164.mjs";
import LinkButton from "./component-library3.mjs";
import "./component-library165.mjs";
import normalizeComponent from "./component-library91.mjs";
const _sfc_main = {
  name: "PaypalButton",
  components: {
    LinkButton,
    PaypalIcon,
    PaypalLogo
  },
  props: {
    label: { type: String, default: "" },
    size: {
      type: String,
      default: "normal",
      validator(value) {
        return ["normal", "large"].includes(value);
      }
    },
    theme: {
      type: String,
      default: "gold",
      validator(value) {
        return ["gold", "white"].includes(value);
      }
    },
    isLabelBefore: { type: Boolean }
  },
  emits: ["click"],
  computed: {
    classes() {
      const modifier = [];
      if (this.theme)
        modifier.push(`paypal-button--${this.theme}`);
      if (this.isLabelBefore)
        modifier.push("paypal-button--label-before");
      return modifier;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("LinkButton", { staticClass: "paypal-button", class: _vm.classes, attrs: { "tag": "button", "type": "button", "large": _vm.size === "large" }, on: { "click": function($event) {
    return _vm.$emit("click");
  } } }, [_c("span", { staticClass: "paypal-button__logo" }, [_c("PaypalIcon", { staticClass: "paypal-button__pp paypal-button__pp--short", attrs: { "aria-label": "pp" } }), _c("PaypalLogo", { staticClass: "paypal-button__pp paypal-button__pp--long", attrs: { "aria-label": "paypal" } })], 1), _vm._t("default", function() {
    return [_vm.label ? _c("span", { staticClass: "paypal-button__label" }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e()];
  })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "97829e37",
  null,
  null
);
const paypalButton = __component__.exports;
export {
  paypalButton as default
};
